import React, { useState } from "react";
import localeText from "../../../../../../locale";
import { Button } from "primereact/button";
import { useToastContext } from "../../../../../../contexts/ToastContext/ToastContext";
import { Dialog } from "primereact/dialog";
import { QRCodeCanvas } from "qrcode.react";
import { useToggle } from "../../../../../../hooks/useToggle";

const ReferralLink = ({ referralUrl, backgroundColor, text }) => {
  const { showInfoToast } = useToastContext();
  const [urlRegisterUser, setUrlRegisterUser] = useState("");
  const {
    value: isOpenQrCodeRegister,
    setAsTrue: openQrCodeRegister,
    setAsFalse: closeQrCodeRegister,
  } = useToggle();

  const openQrCodeRegisterUserModal = (url) => {
    setUrlRegisterUser(url);
    openQrCodeRegister();
  };

  const handleClick = () => {
    JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))
      ? window.ReactNativeWebView.postMessage(
          JSON.stringify({
            content: referralUrl,
            clipboard: true,
          })
        )
      : navigator.clipboard.writeText(referralUrl);
    showInfoToast({ summary: "copied", detail: "copiedToClipboard" });
  };

  return (
    <>
      <Dialog
        header={`${localeText("qrcodereferralLinks")} (${text})`}
        visible={isOpenQrCodeRegister}
        className="w-30rem m-2"
        onHide={closeQrCodeRegister}
        draggable={false}
      >
        <div className="flex flex-column justify-content-center align-items-center gap-2">
          <QRCodeCanvas value={urlRegisterUser} size={200} />
        </div>
      </Dialog>

      <li className="py-2 pl-0 pr-0">
        <div className="flex align-items-center">
          <Button
            label={localeText("copy")}
            icon="pi pi-link"
            iconPos="right"
            className="p-2 mr-2 p-button-rounded p-button-outlined"
            onClick={handleClick}
          />

          <Button
            icon="pi pi-qrcode"
            iconPos="right"
            className="p-2 mr-2 p-button-rounded p-button-outlined"
            onClick={() => openQrCodeRegisterUserModal(referralUrl)}
          />

          <span
            style={{ backgroundColor: backgroundColor, width: 90 }}
            className="text-0 p-1 border-round flex justify-content-center align-items-center"
          >
            {text}
          </span>
        </div>
      </li>
    </>
  );
};

export default ReferralLink;
